export enum InterviewStatus {
  TENTATIVE = 'Tentative',
  ACCEPTED = 'Accepted',
  CANCELLED = 'Cancelled',
  DECLINED = 'Declined',
  COMPLETED = 'Completed'
}

export enum BookingType {
  GROUP = 'GroupBooking',
  INDIVIDUALSPECIFIC = 'IndividualSpecific',
  INDIVIDUALSELECT = 'IndividualSelect'
}

export enum InterviewType {
  REMOTE = 'Remote',
  INPERSON = 'InPerson',
  TELEPHONE = 'Telephone'
}
